import type { ActiveBasketSummaryData, ShippingMethod } from '../../typings/basket.types';

export const getFullBasketPrice = (
    basketSummary: ActiveBasketSummaryData,
    nextShippingMethods: ShippingMethod[],
    preselectedShippingMethodId: string,
) => {
    let deliveryCost = 0;

    let selectedMethod = nextShippingMethods.find((x) => x.id === +preselectedShippingMethodId);
    if (!selectedMethod && nextShippingMethods.length > 0) {
        const [first] = nextShippingMethods.sort((x) => x.cost);
        selectedMethod = first;
    }

    if (selectedMethod) {
        deliveryCost = selectedMethod.cost + selectedMethod.taxCost;
    }

    const rawValue = basketSummary.totalItemPrice - Math.abs(basketSummary.promoTotal) + deliveryCost;
    return Math.round(rawValue * 100) / 100;
};
